import { jsx as _jsx } from "react/jsx-runtime";
export const LogoBlueOnWhite = ({ src, className, }) => (_jsx("div", { className: className, children: _jsx("img", { src: src, alt: "Primary", className: "h-8" }) }));
